import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * Navigation sub item link container
 */
export const navigationSubItemLinkContainerStyles = ({ theme }) => css `
	display: block;
	padding: ${pxToRem(theme.spacing['100'])};
	color: ${theme.colors.base.textMainNavigation};
	border-radius: ${pxToRem(theme.borderRadius.xs)};

	&:hover {
		color: ${theme.colors.highlight.textHover};
		background-color: ${theme.colors.extralight.bgNavigationItemHover};
	}

	&:active {
		color: ${theme.colors.blanc.textInverse};
		background-color: ${theme.colors.base.bgNavigationItemActive};
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: ${theme.borderWidth.m}px;
	}
`;
export const NavigationSubItemLinkContainer = styled(Typography).attrs({
    variant: 'body-text',
    tagName: 'a',
}) `
	${navigationSubItemLinkContainerStyles}
`;
